export default __webpack_public_path__ + "static/sportsrehab-7aee583966bd118bc1bed25f5dddf276.png";